export const BRAND_FACET_KEY = 'ATTR_Brandname';
